/**
 * TAA (Taalbegrip) Module Seeds - DDD Canonical Location
 *
 * All 35 families fully migrated to DDD on 16 maart 2026.
 * All JSON files physically reside in src/content/seeds/TAA/.
 *
 * See docs/guides/HUMAN_REVIEW_GUIDE.md for review process.
 */

import TAA_ONT_BASIS from './TAA-ONT-BASIS.json'
import TAA_SOORT_LID from './TAA-SOORT-LID.json'
import TAA_SOORT_WW from './TAA-SOORT-WW.json'
import TAA_LEZEN_VERW from './TAA-LEZEN-VERW.json'
import TAA_ONT_LV_MV from './TAA-ONT-LV-MV.json'
import TAA_SOORT_VNW from './TAA-SOORT-VNW.json'
import TAA_LEZEN_KERN from './TAA-LEZEN-KERN.json'
import TAA_ONT_BWB from './TAA-ONT-BWB.json'
import TAA_LEZEN_FEIT from './TAA-LEZEN-FEIT.json'
import TAA_LEZEN_VERB from './TAA-LEZEN-VERB.json'
import TAA_SIGNAALWOORD from './TAA-SIGNAALWOORD.json'
import TAA_TEKSTSOORT from './TAA-TEKSTSOORT.json'
import TAA_WOORD_SYNONIEM from './TAA-WOORD-SYNONIEM.json'
import TAA_SOORT_BNW from './TAA-SOORT-BNW.json'
import TAA_ONT_GEZEGDE from './TAA-ONT-GEZEGDE.json'
import TAA_WOORD_ANTONIEM from './TAA-WOORD-ANTONIEM.json'
import TAA_LEZEN_DETAIL from './TAA-LEZEN-DETAIL.json'
import TAA_SOORT_BW from './TAA-SOORT-BW.json'
import TAA_SOORT_TW from './TAA-SOORT-TW.json'
import TAA_WOORD_CONTEXT from './TAA-WOORD-CONTEXT.json'
import TAA_ONT_VOORZETSEL from './TAA-ONT-VOORZETSEL.json'
import TAA_SOORT_VZ from './TAA-SOORT-VZ.json'
import TAA_LEZEN_VOORSPEL from './TAA-LEZEN-VOORSPEL.json'
import TAA_SOORT_VW from './TAA-SOORT-VW.json'
import TAA_LEZEN_SAMENVATTEN from './TAA-LEZEN-SAMENVATTEN.json'
import TAA_ONT_INVERSIE from './TAA-ONT-INVERSIE.json'
import TAA_ONT_NAAMWOORDELIJK from './TAA-ONT-NAAMWOORDELIJK.json'
import TAA_LEZEN_CONCLUSIE from './TAA-LEZEN-CONCLUSIE.json'
import TAA_ONT_HOOFDZIN from './TAA-ONT-HOOFDZIN.json'
import TAA_WOORD_IDIOOM from './TAA-WOORD-IDIOOM.json'
import TAA_ONT_BIJZIN from './TAA-ONT-BIJZIN.json'
import TAA_LEZEN_STRUCTUUR from './TAA-LEZEN-STRUCTUUR.json'
import TAA_ONT_BETREKKELIJK from './TAA-ONT-BETREKKELIJK.json'
import TAA_LEZEN_DOEL from './TAA-LEZEN-DOEL.json'
import TAA_ARGUMENTATIE from './TAA-ARGUMENTATIE.json'
import TAA_ONT_PARSER from './TAA-ONT-PARSER.json'

const TAA_FAMILY_SEEDS = [
  { file: 'src/content/seeds/TAA/TAA-ONT-BASIS.json', data: TAA_ONT_BASIS },
  { file: 'src/content/seeds/TAA/TAA-ONT-GEZEGDE.json', data: TAA_ONT_GEZEGDE },
  { file: 'src/content/seeds/TAA/TAA-SOORT-LID.json', data: TAA_SOORT_LID },
  { file: 'src/content/seeds/TAA/TAA-SOORT-WW.json', data: TAA_SOORT_WW },
  { file: 'src/content/seeds/TAA/TAA-SOORT-BNW.json', data: TAA_SOORT_BNW },
  { file: 'src/content/seeds/TAA/TAA-SOORT-TW.json', data: TAA_SOORT_TW },
  { file: 'src/content/seeds/TAA/TAA-LEZEN-VERW.json', data: TAA_LEZEN_VERW },
  {
    file: 'src/content/seeds/TAA/TAA-LEZEN-DETAIL.json',
    data: TAA_LEZEN_DETAIL,
  },
  { file: 'src/content/seeds/TAA/TAA-ONT-LV-MV.json', data: TAA_ONT_LV_MV },
  { file: 'src/content/seeds/TAA/TAA-SOORT-VNW.json', data: TAA_SOORT_VNW },
  { file: 'src/content/seeds/TAA/TAA-LEZEN-KERN.json', data: TAA_LEZEN_KERN },
  { file: 'src/content/seeds/TAA/TAA-ONT-BWB.json', data: TAA_ONT_BWB },
  { file: 'src/content/seeds/TAA/TAA-LEZEN-FEIT.json', data: TAA_LEZEN_FEIT },
  { file: 'src/content/seeds/TAA/TAA-LEZEN-VERB.json', data: TAA_LEZEN_VERB },
  {
    file: 'src/content/seeds/TAA/TAA-SIGNAALWOORD.json',
    data: TAA_SIGNAALWOORD,
  },
  { file: 'src/content/seeds/TAA/TAA-TEKSTSOORT.json', data: TAA_TEKSTSOORT },
  {
    file: 'src/content/seeds/TAA/TAA-WOORD-SYNONIEM.json',
    data: TAA_WOORD_SYNONIEM,
  },
  {
    file: 'src/content/seeds/TAA/TAA-WOORD-ANTONIEM.json',
    data: TAA_WOORD_ANTONIEM,
  },
  {
    file: 'src/content/seeds/TAA/TAA-WOORD-CONTEXT.json',
    data: TAA_WOORD_CONTEXT,
  },
  {
    file: 'src/content/seeds/TAA/TAA-SOORT-BW.json',
    data: TAA_SOORT_BW,
  },
  {
    file: 'src/content/seeds/TAA/TAA-ONT-VOORZETSEL.json',
    data: TAA_ONT_VOORZETSEL,
  },
  {
    file: 'src/content/seeds/TAA/TAA-SOORT-VZ.json',
    data: TAA_SOORT_VZ,
  },
  {
    file: 'src/content/seeds/TAA/TAA-LEZEN-VOORSPEL.json',
    data: TAA_LEZEN_VOORSPEL,
  },
  {
    file: 'src/content/seeds/TAA/TAA-SOORT-VW.json',
    data: TAA_SOORT_VW,
  },
  {
    file: 'src/content/seeds/TAA/TAA-LEZEN-SAMENVATTEN.json',
    data: TAA_LEZEN_SAMENVATTEN,
  },
  {
    file: 'src/content/seeds/TAA/TAA-ONT-INVERSIE.json',
    data: TAA_ONT_INVERSIE,
  },
  {
    file: 'src/content/seeds/TAA/TAA-ONT-NAAMWOORDELIJK.json',
    data: TAA_ONT_NAAMWOORDELIJK,
  },
  {
    file: 'src/content/seeds/TAA/TAA-LEZEN-CONCLUSIE.json',
    data: TAA_LEZEN_CONCLUSIE,
  },
  {
    file: 'src/content/seeds/TAA/TAA-ONT-HOOFDZIN.json',
    data: TAA_ONT_HOOFDZIN,
  },
  {
    file: 'src/content/seeds/TAA/TAA-WOORD-IDIOOM.json',
    data: TAA_WOORD_IDIOOM,
  },
  {
    file: 'src/content/seeds/TAA/TAA-ONT-BIJZIN.json',
    data: TAA_ONT_BIJZIN,
  },
  {
    file: 'src/content/seeds/TAA/TAA-LEZEN-STRUCTUUR.json',
    data: TAA_LEZEN_STRUCTUUR,
  },
  {
    file: 'src/content/seeds/TAA/TAA-ONT-BETREKKELIJK.json',
    data: TAA_ONT_BETREKKELIJK,
  },
  {
    file: 'src/content/seeds/TAA/TAA-LEZEN-DOEL.json',
    data: TAA_LEZEN_DOEL,
  },
  {
    file: 'src/content/seeds/TAA/TAA-ARGUMENTATIE.json',
    data: TAA_ARGUMENTATIE,
  },
  {
    file: 'src/content/seeds/TAA/TAA-ONT-PARSER.json',
    data: TAA_ONT_PARSER,
  },
] as const

const allQuestions = TAA_FAMILY_SEEDS.flatMap(({ file, data }) =>
  data.questions.map((question) => ({ ...question, __sourceFile: file })),
)

export default {
  module: 'Taalbegrip' as const,
  moduleCode: 'TAA',
  version: '6.0-parser-type',
  taxonomyVersion: '4.1',
  questions: allQuestions,
}
